import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, Outlet, useLocation } from "react-router-dom";
import { Avatar, Layout, Menu, Modal, theme } from "antd";
import logo from "../../images/coinzone_logo.svg";

import iconCoin from "../../images/coins.png";

import priceolan from "../../images/priceplan.png";
import {
   AlertOutlined,
   DashboardOutlined,
   KeyOutlined,
   LogoutOutlined,
   SecurityScanOutlined,
   SettingOutlined,
   UsergroupAddOutlined,
   DatabaseOutlined,
} from "@ant-design/icons";

import { logout } from "../../redux/slice/user.slice";
import { setToast } from "../../redux/slice/toast.slice";
import storageService from "../../utils/storage";

const { Header, Sider, Content } = Layout;

const navbarArr = [
   { pathname: "/dashboard", value: "1" },
   { pathname: "/venders-list", value: "2" },
   { pathname: "/coin-list", value: "3" },
   { pathname: "/settings", value: "4" },
   { pathname: "/planslist", value: "5" },
   { pathname: "/third-party-keys/states", value: "6" },
   { pathname: "/cache-dashboard", value: "7" },
];

const MainLayout = () => {
   const dispatch = useDispatch();
   const isAdmin = useSelector((state) => state.userState?.user?.role) === "admin";
   const location = useLocation();
   const [collapsed, setCollapsed] = useState(true);
   const [logoutModalOpen, setLogoutModalOpen] = useState(false);

   const [activeIndex, setActiveIndex] = useState("");
   
   // Get admin data from centralized storage service
   const adminEmail = storageService.getAdminEmail();

   const {
      token: { colorBgContainer },
   } = theme.useToken();

   const onLogout = () => {
      dispatch(logout(null));
      dispatch(
         setToast({
            message: "Logout successfully",
            success: true,
            error: false,
         })
      );
   };

   let menuItems = [{
      label: <Link to="/dashboard"> Dashboard </Link>,
      key: "dashboard",
      icon: <DashboardOutlined />
   }, {
      label: <Link to="/venders-list"> Venders List </Link>,
      key: "vendersList",
      icon: <UsergroupAddOutlined />
   }, {
      key: "coins",
      label: "Coins",
      icon: <img src={iconCoin} width={20} alt="Coins" />,
      children: [{
         label: <Link to="/coin-list"> Coins List </Link>,
         key: "coinsList",
      }]
   }, {
      key: "keys",
      label: "Keys",
      icon: <KeyOutlined />,
      children: [{
         label: <Link to="/third-party-keys/states"> Keys States </Link>,
         key: "keysStates"
      }, {
         label: <Link to="/third-party-keys/keylist"> Third Party Keys </Link>,
         key: "thirdPartyKeys"
      }]
   }, {
      key: "planslist",
      label: <Link to="/planslist"> Plans list </Link>,
      icon: <img src={priceolan} width={16} height={16} alt="Plans" />
   }, ...(isAdmin ? [{
      key: "cache",
      label: <Link to="/cache-dashboard"> Cache Dashboard </Link>,
      icon: <DatabaseOutlined />
   }] : []), {
      key: "settings",
      label: <Link to="#"> Settings </Link>,
      icon: <SettingOutlined />,
      children: [{
         label: <Link to="/settings/security"> Security </Link>,
         key: "settingsSecurity",
         icon: <SecurityScanOutlined />
      }, {
         label: <Link to="/settings/users-alert"> Alert notification </Link>,
         key: "settingsUsersAlert",
         icon: <AlertOutlined />
      }]
   }, {
      key: "logout",
      label: "Logout",
      icon: <LogoutOutlined />,
      onClick: () => {
         setLogoutModalOpen(true);
      },
   }];

   useEffect(() => {
      navbarArr.forEach((item) => {
         if (item.pathname === location.pathname) {
            setActiveIndex(item.value);
         }
      });
   }, [location.pathname]);

   return (
      <>
         <Layout className="layout adminMainLayout" style={{ background: colorBgContainer }}>
            <Header className="dashboard-header" role="banner">
               <div className="logo displayFlex">
                  <Link to={`/dashboard`} aria-label="Go to dashboard">
                     <img alt="CoinZone Logo" src={logo}></img>
                  </Link>
               </div>

               <div 
                  className="headerNameRgtCol" 
                  role="button" 
                  tabIndex={0}
                  aria-label={`User menu for ${adminEmail}`}
                  onKeyDown={(e) => {
                     if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        // Add user menu functionality if needed
                     }
                  }}
               >
                  <span className="headerNameSec" style={{ marginRight: "8px" }}>
                     <span style={{ fontWeight: "700" }}> Welcome: </span>
                     <span className="headerAdminName" style={{ fontWeight: "500" }}> {adminEmail} </span>
                  </span>
                  <Avatar 
                     style={{ backgroundColor: '#f56a00' }}
                     aria-label={`User avatar for ${adminEmail}`}
                  >
                     {adminEmail?.charAt(0)?.toUpperCase()}
                  </Avatar>
               </div>
            </Header>
         </Layout >

         <Layout className="main-layout" style={{
            // minHeight: "90vh"
         }} >
            <Sider
               className="dashboard-sidebar"
               style={{ backgroundColor: "white", color: "black" }}
               collapsible
               collapsed={collapsed}
               onCollapse={(value) => setCollapsed(value)}
               aria-label="Main navigation sidebar"
            >
               <div className="demo-logo-vertical" />
               <Menu
                  theme="light"
                  selectedKeys={[activeIndex]}
                  mode="inline"
                  items={menuItems}
               />
            </Sider>
            <Content
               className="main content-section"
               role="main"
            >
               <Layout
                  className="site-layout-content"
                  style={{ backgroundColor: "#f0f2f5" }}
               >
                  <Outlet />
               </Layout>
            </Content>
         </Layout>

         <Modal
            id="logoutModal"
            title="Do you want to Logout?"
            centered
            open={logoutModalOpen}
            onOk={() => onLogout(false)}
            onCancel={() => setLogoutModalOpen(false)}
            width={500}
            okText={"Yes"}
            cancelText={"No"}
            aria-labelledby="logout-modal-title"
         >
            <p id="logout-modal-title" className="sr-only">Confirmation dialog for logging out</p>
         </Modal>
      </>
   );
};
export default MainLayout;
